import baseRequest from "../_core/baseRequest";

// Custom serializer for array parameters without brackets
const serializeParams = params => {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
        const value = params[key];
        if (Array.isArray(value)) {
            value.forEach(item => searchParams.append(key, item));
        } else if (value !== undefined && value !== null) {
            searchParams.append(key, value);
        }
    });
    return searchParams.toString();
};

export default {
    getShiftRequestList: params => {
        const queryString = serializeParams(params);
        return baseRequest.get(`/shifts/request?${queryString}`);
    },
    getShiftRequestDetails: params => baseRequest.get(`/shifts/request/details/${params.id}`),
    createShiftRequest: params => baseRequest.post("/shifts/request", params),
    createShiftRequestNote: params => baseRequest.post("/shifts/request/note", params),
    updateRequestStatus: params => baseRequest.post("/shifts/request/status-update", params),
    exportShiftRequestExcel: params => baseRequest.post("/shifts/request/export", params, true),
    cancelShiftRequest: params => baseRequest.put(`/shifts/request/${params?.id}/cancel`, params)
};
